import { render } from "./ModalUbicaciones.vue?vue&type=template&id=0ee96386&scoped=true"
import script from "./ModalUbicaciones.vue?vue&type=script&lang=js"
export * from "./ModalUbicaciones.vue?vue&type=script&lang=js"

import "./ModalUbicaciones.vue?vue&type=style&index=0&id=0ee96386&scoped=true&lang=css"

import exportComponent from "/home/alberto/repos/veltium/lan/web-firebase/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee96386"]])

export default __exports__